import { useEffect, useState } from 'react';
import { PaymentRailSettingsApi } from '@/api/clients/payment-rail-settings/payment-rail-settings.api';

export const useGetPaymentRailSettingsForForm = (enabled = true) => {
  const [paymentRailSettings, setPaymentRailSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setPaymentRailSettings([]);
      setLoading(false);
      setError(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    PaymentRailSettingsApi.getForForms()
      .then((res) => {
        if (cancelled) return;
        setPaymentRailSettings(res.data?.data || []);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(
          err.response?.data?.message ||
            'Failed to fetch payment rail settings',
        );
        console.error('Error fetching payment rail settings:', err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { paymentRailSettings, loading, error };
};
